// extracted by mini-css-extract-plugin
module.exports = {"flags":"Flags_flags__KHvct","flag":"Flags_flag__nYY1g","NEW":"Flags_NEW__1geR_","PERCENT_OFF":"Flags_PERCENT_OFF__1X_UT","TRENDING":"Flags_TRENDING__1YWRk"};